// extracted by mini-css-extract-plugin
export default {"svg":"Edit_svg__fB5XI"};